/// <reference path="../../src/window.d.ts" />
import '../common/common';
import $ from 'jquery';
import Notiflix from 'notiflix';

function renderRecaptcha() {
    if (!window.grecaptcha || !window.recaptchaSiteKey || window.recaptchaSiteKey === 'YOUR_RECAPTCHA_SITE_KEY') {
        return;
    }
    window.grecaptcha.render('recaptcha-widget', {
        sitekey: window.recaptchaSiteKey,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderRecaptcha);
} else {
    renderRecaptcha();
}

$('#affiliate-form').on('submit', function (evt) {
    evt.preventDefault();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const recaptchaResponse = (window as any).grecaptcha?.getResponse();
    if (!recaptchaResponse) {
        Notiflix.Notify.failure('Please complete the reCAPTCHA verification.', {
            clickToClose: true,
        });
        return;
    }

    const formData = new FormData(evt.target as HTMLFormElement);
    const formProps = Object.fromEntries(formData);
    const affiliateApplyQuery = `
      mutation CreateAffiliate($input: AffiliateAddInput!){
        createAffiliate(input: $input){
          id
        }
      }
      `;
    $.ajax({
        method: 'POST',
        url: `${window.backend_url}`,
        contentType: 'application/json',
        xhrFields: {
            withCredentials: true,
        },
        crossDomain: true,
        data: JSON.stringify({
            query: affiliateApplyQuery,
            variables: {
                input: {
                    firstName: formProps.firstName,
                    lastName: formProps.lastName,
                    emailAddress: formProps.emailAddress,
                    password: formProps.password,
                    contactID:
                        formProps.contactID && formProps.contactID != ''
                            ? formProps.contactID
                            : null,
                    website:
                        formProps.website && formProps.website != ''
                            ? formProps.website
                            : null,
                    introduction:
                        formProps.introduction && formProps.introduction != ''
                            ? formProps.introduction
                            : null,
                    recaptchaToken: recaptchaResponse,
                },
            },
        }),
        success: function (data) {
            if (data.errors) {
                const theMessage = data.errors[0].message || "Something went wrong. Please try again later.";
                Notiflix.Notify.failure(theMessage, { clickToClose: true });
            } else {
                $("#affiliate-form").replaceWith($(`
                    <h2>Your application has been submitted successfully.</h2>
                    <p>We will review your application and get back to you shortly.</p>
                `));
            }
        },
        error: function (err) {
            Notiflix.Notify.failure("Something went wrong. Please try again later!", { clickToClose: true });
        },
    });
});